@if (loading) {
  @if (isDocumentRoute) {
    <loading class="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center"></loading>
  } @else {
    <app-instant-checkup-loader class="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center" />
  }
}
@if (!loading) {
  <header class="tw-flex-none tw-w-full">
    <div class="tw-h-14 tw-px-6 tw-flex tw-items-center tw-w-full tw-justify-center tw-z-[100] tw-bg-gray-800 tw-font-lexend">
      <div class="tw-absolute tw-left-6 tw-top-2 tw-flex tw-items-center tw-justify-center tw-rounded-xl tw-h-10 tw-w-10 tw-bg-gray-800"
        (click)="back()">
        <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50"
        [iconName]="'arrow_back'"></cs-icon>
      </div>
      @switch (headerType) {
        @case (HeaderTypeEnum.SKIN_ANALYSIS_RESULT) {
          <span class="tw-font-bold tw-text-300 tw-text-white"
          i18n="@@skinAnalysisResult">Skin analysis result</span>
        }
        @case (HeaderTypeEnum.HAIR_ANALYSIS_RESULT) {
          <span class="tw-font-bold tw-text-300 tw-text-white"
          i18n="@@hairAnalysisResult">Hair analysis result</span>
        }
        @case (HeaderTypeEnum.ANALYSIS_RESULT) {
          <span class="tw-font-bold tw-text-300 tw-text-white"
          i18n="@@analysisResult">Analysis result</span>
        }
        @case (HeaderTypeEnum.DATE) {
          <span class="tw-text-300 tw-text-white">{{ today | date:'MMMM d, y' }}</span>
        }
        @case (HeaderTypeEnum.CURESKIN_LOGO) {
          <img [src]="logoImageSrc"
               [alt]="isHairCheckup ? 'Curehair Logo' : 'Cure Logo'"
               class="tw-w-full tw-h-full tw-max-w-[90px] tw-max-h-4">
        }
        @case (HeaderTypeEnum.DOCUMENT_VIEW) {
          <span class="tw-font-bold tw-text-300 tw-text-white">
            <translate-string [key]="'uploadedDocument'"></translate-string>
          </span>
        }
        @default {
          <span class="tw-font-bold tw-text-300 tw-text-white"
          i18n="@@skinAnalysisResult">Skin analysis result</span>
        }
      }
      @if (!isFollowUpReportPending) {
        <div
          class="tw-absolute tw-right-6 tw-top-2 tw-flex tw-items-center tw-justify-center tw-rounded-xl tw-h-10 tw-w-10 tw-bg-gray-800">
          <cs-icon class="tw-h-10 tw-w-10"
            [iconName]="'delete'"
            (click)="deleteInstantCheckup()">
          </cs-icon>
        </div>
      }
    </div>
  </header>
  <!-- Simple image view for document/report types -->
  @if (isDocumentType) {
    <main class="tw-flex-auto tw-flex tw-items-center tw-justify-center tw-max-w-full tw-overflow-auto tw-bg-gray-100">
      <img [src]="instantCheckup?.imagePath" class="tw-max-w-full tw-max-h-full tw-object-contain" alt="document">
    </main>
  }
  @if (!isDocumentType) {
  <!-- Detections selection pills -->
  <!-- Here - !['HAIR_FRONT'].includes(instantCheckup.type) is an unnecessary check because for results will be undefined if it is hair front - logic is in component-->
  <!-- Hide tabs for HAIR_TOP type (scalp-segment) -->
  @if (results?.length && ![appConfig.Shared.InstantCheckup.Type.HAIR_FRONT, appConfig.Shared.InstantCheckup.Type.HAIR_TOP].includes(instantCheckup.type)) {
    <section
      class="tw-flex-none tw-flex tw-items-center tw-gap-1 tw-py-2 tw-pl-4 tw-z-10 tw-overflow-x-scroll tw-backdrop-blur tw-bg-gray-100">
      <div class="tw-flex tw-items-center tw-justify-center tw-text-300 tw-text-gray-900 tw-bg-gray-50 tw-rounded-full tw-px-4 tw-w-max tw-whitespace-nowrap tw-transition-all tw-shadow-z1 tw-font-lexend tw-h-[37px]"
         [ngClass]="{
                      'tw-text-gray-50': !selectedDetection?.class,
                      'tw-bg-gray-50 tw-text-gray-900': !!selectedDetection?.class,
                      'tw-bg-gray-800': !selectedDetection?.class
                    }"
        (click)="selectedDetection = null; slide();  slide(swiperRefOverlay); redrawScaledCanvas(zoomBox)"
        i18n="@@allConcerns">
      All
    </div>
      @for (detection of results; track detection) {
        <div
          class="tw-flex tw-items-center tw-justify-center tw-text-300 tw-text-gray-900 tw-bg-gray-50 tw-rounded-full tw-px-4 tw-w-max tw-whitespace-nowrap tw-transition-all tw-shadow-z1 tw-font-lexend tw-h-[37px]"
         [ngClass]="{
                      'tw-text-gray-50': detection?.class === selectedDetection?.class,
                      'tw-bg-gray-50 tw-text-gray-900': detection?.class !== selectedDetection?.class,
                      'tw-bg-gray-800': detection?.class === selectedDetection?.class
                    }"
          [appScrollToView]="detection?.class === selectedDetection?.class"
          (click)="selectedDetection = detection; slide();  slide(swiperRefOverlay); redrawScaledCanvas(zoomBox)">
          {{ problemsCopy[user?.get('languagePreference') || 'en'][detection.class]?.name}}
        </div>
      }
    </section>
  }
  @if (showDetectionViewToggle()) {
    <section class="tw-absolute tw-top-[68px] tw-left-2 tw-w-fit tw-rounded-full tw-flex-none tw-flex tw-items-center tw-gap-1 tw-p-0.5 tw-z-10 tw-font-lexend tw-overflow-x-scroll tw-backdrop-blur tw-bg-gray-50">
      <div class="tw-absolute tw-top-0.5 tw-bottom-0.5 tw-rounded-full tw-ease-out tw-z-0 tw-bg-gray-800"
        [style.left.px]="detectionViewIndicatorLeft()"
        [style.width.px]="detectionViewIndicatorWidth()"
      [style.transition]="'left ' + DETECTION_VIEW_INDICATOR_TRANSITION_MS + 'ms ease-out, width ' + DETECTION_VIEW_INDICATOR_TRANSITION_MS + 'ms ease-out'"></div>
      <div #detectionFilledPill
        class="tw-min-w-16 tw-relative tw-z-10 tw-flex tw-items-center tw-justify-center tw-font-body tw-text-200 tw-rounded-full tw-py-1 tw-whitespace-nowrap"
        [style.transition]="'color ' + DETECTION_VIEW_INDICATOR_TRANSITION_MS + 'ms ease-out'"
        [ngClass]="getDetectionViewPillClasses(appConfig.Shared.InstantCheckup.Detections.View.FILLED)"
        (click)="applyDetectionViewMode(appConfig.Shared.InstantCheckup.Detections.View.FILLED, 'toggle')"
        i18n="@@filled">
          Filled
        </div>
      <div #detectionOutlinedPill
        class="tw-min-w-16 tw-relative tw-z-10 tw-flex tw-items-center tw-justify-center tw-font-body tw-text-200 tw-rounded-full tw-py-1 tw-px-2.5 tw-whitespace-nowrap"
        [style.transition]="'color ' + DETECTION_VIEW_INDICATOR_TRANSITION_MS + 'ms ease-out'"
        [ngClass]="getDetectionViewPillClasses(appConfig.Shared.InstantCheckup.Detections.View.OUTLINE)"
        (click)="applyDetectionViewMode(appConfig.Shared.InstantCheckup.Detections.View.OUTLINE, 'toggle')"
        i18n="@@outlined">
          Outlined
        </div>
    </section>
  }
  @if (fromSelfCheckupBanner) {
    <div class="tw-overflow-hidden tw-whitespace-nowrap tw-bg-teal-100 tw-text-200 tw-font-body tw-text-teal-600 tw-font-semibold">
      <div class="tw-flex tw-w-max">
        <div class="tw-flex tw-min-w-max">
          @for (item of [0,1,2,3,4]; track item) {
            <div
              class="tw-w-max tw-px-4 tw-py-2 tw-text-center tw-animate-marquee"
              i18n="@@doctorWillCreateYourReport">Your doctor will use this photo to create a detailed progress report.
            </div>
          }
        </div>
      </div>
    </div>
  }
  @if (showPhotoReviewDisclaimer) {
    <div class="tw-font-body tw-font-bold tw-text-100">
      @if (instantCheckupStatusBannerState === InstantCheckupStatusBannerStateEnum.PHOTO_REVIEWED) {
        <div class="tw-px-4 tw-text-orange-400 tw-bg-orange-100 tw-font-bold tw-py-2 tw-w-full tw-text-center"
          i18n="@@photoReviewed"> This photo was last reviewed by your dermatologist on
          {{user.get('refreshDate') | date: 'dd MMM yyyy'}}. </div>
      }
      @if (instantCheckupStatusBannerState === InstantCheckupStatusBannerStateEnum.PHOTO_REVIEW_PENDING) {
        <div class="tw-px-4 tw-text-orange-400 tw-bg-orange-100 tw-font-bold tw-py-2 tw-w-full tw-text-center"
        i18n="@@photoReviewPending"> This photo is pending review by your dermatologist. </div>
      }
      @if (instantCheckupStatusBannerState === InstantCheckupStatusBannerStateEnum.PHOTO_WILL_BE_REVIEWED) {
        <div class="tw-px-4 tw-text-orange-400 tw-bg-orange-100 tw-font-bold tw-py-2 tw-w-full tw-text-center"
             i18n="@@photoWillBeReviewedNew"> Your assigned Cure dermatologist will review this photo after you
          order the treatment kit. </div>
      }
    </div>
  }
  <!-- Canvas drawing area -->
  <main #main
    class="tw-flex-auto tw-flex tw-flex-col tw-max-w-full tw-overflow-hidden tw-bg-black">
    <div #zoomBox
      class="tw-relative tw-h-full tw-w-full tw-transition-all transition tw-duration-300 tw-ease-in-out"
      (click)="toggleDetectionView()">
      <canvas #imageCanvas
        class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full"
        [appDrawImage]="image"
        [faceLandmarks]="hairTopFaceLandmarks"
        [fitWidth]="isHairTopType || isHairFrontType"
        [detectionVerticalOffset]="detectionVerticalOffset"
      (croppingConfig)="croppingConfig = $event"></canvas>
      @for (detection of results; track detection; let isEven = $even) {
        <canvas class="tw-absolute tw-left-0 tw-top-0 tw-transition-all"
                [ngClass]="{
                                                  'tw-animate-fade_in_right': isEven && !selectedDetection,
                                                  'tw-animate-fade_in_left': !isEven && !selectedDetection,
                                                  'tw-animate-fade_out_right': isEven && selectedDetection && detection?.class !== selectedDetection?.class,
                                                  'tw-animate-fade_out_left': !isEven && selectedDetection && detection?.class !== selectedDetection?.class,
                                                }"
          [height]="imageCanvas?.clientHeight"
          [width]="imageCanvas?.clientWidth"
          [appDrawDetections]="detection"
          [config]="croppingConfig"
          [filled]="isDetectionFilled(detection)"
          [outlineLineWidth]="isDetectionOutlined() ? 2 : null"
        [class.tw-drop-shadow-mint-glow]="shouldShowMintGlow(detection)"></canvas>
      }
      <swiper #swiperRefOverlay
        class="tw-absolute tw-left-0 tw-top-0 tw-transition-all tw-h-full tw-w-full"
        (slideChange)="selectDetection($event); slide(); redrawScaledCanvas(zoomBox);">
        <div *swiperSlide
        class="tw-h-full tw-w-full"></div>
        @for (detection of results; track detection) {
          <div *swiperSlide
          class="tw-h-full tw-w-full"></div>
        }
      </swiper>
      @if (blurWithConcernsDetected && handleBlurPhotosExperiment) {
        <div
          class="tw-absolute tw-top-3 tw-left-3 tw-right-3 tw-bg-orange-50 tw-border tw-border-orange-400 tw-px-4 tw-py-1 tw-mb-4 tw-text-left tw-rounded-lg tw-flex tw-justify-start tw-items-start">
          <img src="/assets/icons/warning.svg"
            alt="warning_icon"
            class="tw-w-4 tw-h-4 tw-mr-1" />
          <h1 i18n="@@unclearImageError"
            class="tw-text-orange-400 tw-text-200 tw-font-body tw-font-bold">Image not clear, it is advised to retake
            photo</h1>
        </div>
      }
    </div>
  </main>
  <!-- Detection card carousel -->
  @if (showFooter) {
    <footer
      class="tw-flex-none tw-pb-1 tw-bg-gray-100 tw-overflow-visible"
      [ngClass]="footerHeightClass">
      @if (['LEFT_SIDE_FACE', 'FRONT_FACE', 'RIGHT_SIDE_FACE'].includes(instantCheckup.type)) {
        <swiper
          #swiperRef
          [config]="carouselConfig"
          class="-tw-mt-44 tw-px-4 tw-h-60 tw-overflow-visible tw-relative"
          (slideChange)="selectDetection($event); slide(swiperRefOverlay); redrawScaledCanvas(zoomBox);">
          <div *swiperSlide
            class="tw-px-6 tw-py-4 tw-mr-3 tw-box-border tw-bg-white tw-rounded-xl tw-z-20 tw-h-[136px] tw-overflow-hidden tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-transition-all tw-duration-200 tw-ease-in-out"
            [ngClass]="!selectedDetection?.class ? 'tw-shadow-z3': ''"
            (click)="selectDetection({activeIndex: 1}); slide(swiperRef)">
            <div class="tw-font-lexend">
              @if (headerType === HeaderTypeEnum.CURESKIN_LOGO || headerType === HeaderTypeEnum.DATE) {
                <span class="tw-font-bold tw-text-500 tw-mb-1"
                i18n="@@skinAnalysisResult">Skin analysis result</span>
              } @else {
                <span class="tw-font-bold tw-text-500 tw-mb-1"
                i18n="@@summary"> Summary </span>
              }
              <div class="tw-flex tw-items-center tw-justify-start tw-gap-1 tw-mb-1">
                <h1 class="tw-text-yellow-400 tw-text-200 tw-font-bold"
                  i18n="@@concernsDetected">
                    {{results.length}}&nbsp;@if (results.length === 1) {
                      <span>Concern</span>
                     } @if (results.length !== 1) {
                       <span>Concerns</span>
                     } Detected
                </h1>
              </div>
              @if (!responsiveCardReadMoreExperiment) {
                <span class="tw-text-200 tw-text-gray-700 tw-h-[54px] tw-text-ellipsis">
                  @for (item of results; track item; let isLast = $last) {
                    {{ problemsCopy[user?.get('languagePreference') ||
                    'en'][item?.class]?.name }}@if (!isLast) { <span>, </span> }
                  }
                </span>
              }
              @if (responsiveCardReadMoreExperiment) {
                <app-read-more class="tw-font-body tw-text-200"
                  [isExpanded]="summaryExpanded"
                  [text]="summaryFullText"></app-read-more>
              }
            </div>
          </div>
        @for (item of results; track item; let i = $index) {
          <div *swiperSlide
            class="tw-px-6 tw-py-4 tw-mr-3 tw-box-border tw-bg-white tw-rounded-xl tw-z-20 tw-overflow-hidden tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-transition-all tw-duration-200 tw-ease-in-out"
            [ngClass]="(selectedDetection?.class === item?.class ? 'tw-shadow-z3 tw-bg-white' : 'tw-bg-gray-100') + ' ' + (expandedItems[i] ? 'tw-h-fit' : 'tw-h-[136px]')">
            <div
              class="tw-font-lexend tw-font-bold tw-text-500 tw-mb-1 tw-line-clamp-1 tw-overflow-hidden tw-text-ellipsis">
              {{ problemsCopy[user?.get('languagePreference') ||
              'en'][item?.class]?.name }}
            </div>
            <div class="tw-flex tw-items-center tw-justify-start tw-gap-1 tw-mb-1 tw-leading-4">
              <h1 class="tw-font-lexend tw-text-200 tw-font-bold"
                [ngClass]="{
                  'tw-text-gray-400': item?.severity === concernSeverity.Mild,
                  'tw-text-yellow-400': item?.severity === concernSeverity.Moderate,
                  'tw-text-orange-500': item?.severity === concernSeverity.Severe,
            }">
                {{concernSeverityTranslations?.[user?.get('languagePreference')
                ||'en']?.[item?.severity]}}
              </h1>
              @if (item?.severity === concernSeverity.Severe) {
                <cs-icon
                  class="tw-w-[13px] tw-h-[13px]"
                [iconName]="'severe-vector'"></cs-icon>
              }
            </div>
            <div>
              @if (!responsiveCardReadMoreExperiment) {
                <div
                  class="tw-font-lexend tw-text-200 tw-h-[54px] tw-text-gray-700 tw-line-clamp-3 tw-overflow-hidden tw-text-ellipsis">
                  {{problemsCopy[user?.get('languagePreference')
                  ||'en'][item?.class]?.info}}
                </div>
              }
              @if (responsiveCardReadMoreExperiment) {
                <app-read-more
                  class="tw-font-body tw-text-200"
                  [isExpanded]="expandedItems[i]"
                           [text]="problemsCopy[user?.get('languagePreference')
                                    || this.appConfig.Shared.Languages.EN][item?.class]?.info"></app-read-more>
              }
            </div>
          </div>
        }
      </swiper>
    }
    <!-- HAIR_TOP scalp-segment card -->
    @if (showScalpCard) {
      @if (showHairTopWithScores) {
        <div class="tw-px-4 tw-overflow-visible tw-relative"
          [class.-tw-mt-18]="isDravidianScriptUser"
          [class.-tw-mt-20]="!isDravidianScriptUser">
          <div class="tw-bg-white tw-rounded-4.5 tw-shadow-z4 tw-px-5 tw-pt-5 tw-pb-3 tw-z-20 tw-overflow-visible tw-relative tw-box-border">
            <div class="tw-font-lexend tw-font-bold tw-text-gray-800 tw-leading-5"
              [class.tw-text-400]="isDravidianScriptUser"
              [class.tw-text-650]="!isDravidianScriptUser">{{ scalpParameterCardCopy?.title }}</div>
            <div class="tw-border-t tw-border-gray-200 tw-my-3"
            ></div>
            @if (showScalpParameterBars) {
              <app-scalp-parameter-bars [parameters]="scalpParameters" />
            }
            @if (isNoScalpDetectionState) {
              <div class="tw-font-body tw-text-200 tw-font-medium tw-text-gray-500">
                <div class="tw-font-semibold tw-mb-1">{{ scalpParameterCardCopy?.reasonsHeading }}</div>
                <ul class="tw-list-disc tw-list-inside tw-space-y-0.5">
                  @for (reason of scalpParameterCardCopy?.reasons; track reason) {
                    <li>{{ reason }}</li>
                  }
                </ul>
              </div>
            } @else {
              <p class="tw-font-body tw-text-200 tw-font-medium tw-text-gray-500"
                [class.tw-mt-4]="showScalpParameterBars"
                [class.tw-text-100]="isDravidianScriptUser"
                [class.tw-text-200]="!isDravidianScriptUser">
              {{ scalpParameterCardCopy?.description }}</p>
            }
          </div>
        </div>
      } @else {
        <!-- Legacy scalp card (hair_top_with_scores off) -->
        <div [ngClass]="scalpCardOffsetClass" class="tw-px-4 tw-overflow-visible tw-relative">
          <div [ngClass]="scalpCardHeightClass" class="tw-px-5 tw-shadow-z3 tw-py-4 tw-box-border tw-bg-white tw-rounded-xl tw-z-20 tw-overflow-visible tw-font-body">
            <div [class]="scalpCardTitleSizeClass" class="tw-font-bold tw-mb-1">
              @if (scalpSeverityCopyEnabled) {
                {{ scalpParameterCardCopy?.title }}
              } @else if (scalpCardState === ScalpCardState.NoDetection) {
                <span i18n="@@noVisibleScalpArea">No visible scalp area</span>
              } @else {
                {{ legacyScalpCardTitle }}
              }
            </div>
            @if (showScalpDetectionSeverity) {
              <div class="tw-flex tw-items-center tw-justify-start tw-gap-1 tw-mb-1 tw-leading-4">
                <h1 class="tw-font-body tw-text-200 tw-font-bold tw-uppercase tw-text-orange-500">
                  {{ translatedScalpDetectionSeverity }}
                </h1>
              </div>
            }
            <div [ngClass]="scalpCardDescriptionClampClass"
              [class]="scalpCardDescriptionSizeClass"
              class="tw-text-gray-700 tw-overflow-hidden tw-text-ellipsis">
              @if (scalpSeverityCopyEnabled) {
                @if (scalpCardState === ScalpCardState.NoDetection) {
                  <div>
                    <div class="tw-font-semibold tw-mb-1">{{ scalpParameterCardCopy?.reasonsHeading }}</div>
                    <ul class="tw-list-disc tw-list-inside tw-space-y-0.5">
                      @for (reason of scalpParameterCardCopy?.reasons; track reason) {
                        <li>{{ reason }}</li>
                      }
                    </ul>
                  </div>
                } @else {
                  <p>{{ scalpParameterCardCopy?.description }}</p>
                }
              } @else {
                @switch (scalpCardState) {
                  @case (ScalpCardState.Detected) {
                    @if (user?.get('Gender') === ApiClientConstant.User.Gender.FEMALE) {
                      <p i18n="@@scalpDetectionDescFemale">Scalp visibility along hair partition is common. But, if the partition appears wider than usual, it indicates increased hair fall or thinning.</p>
                    }
                    @if (user?.get('Gender') === ApiClientConstant.User.Gender.MALE) {
                      <p i18n="@@scalpDetectionDescMale">Scalp visibility along hair partition is common. But, increased visibility around the hairline/crown may indicate progressive hair thinning or baldness.</p>
                    }
                  }
                  @case (ScalpCardState.Normal) {
                    <p i18n="@@scalpNormalDescription">Based on your photo, your hair appears to have good coverage with no clear signs of hair loss at this stage.</p>
                  }
                  @default {
                    <div [ngClass]="[appConfig.Shared.Languages.KN, appConfig.Shared.Languages.TE, appConfig.Shared.Languages.TA].includes(user.get('languagePreference')) ? 'tw-text-100' : 'tw-text-200'">
                      <div class="tw-font-semibold tw-mb-1" i18n="@@possibleReasons">Possible Reasons:</div>
                      <ul class="tw-list-disc tw-list-inside tw-space-y-0.5">
                        <li i18n="@@highHairDensity">Hair density is high with minimal scalp visibility</li>
                        <li i18n="@@unclearTopViewPhoto">The top-view photo isn't clear</li>
                        <li i18n="@@lightingOrBlurIssue">Low or excess lighting or blur photo</li>
                        <li i18n="@@hairTopNotPresent">Hair top not present in photo</li>
                      </ul>
                    </div>
                  }
                }
              }
            </div>
          </div>
        </div>
      }
    }
    @if (showHairFrontCard) {
      <div
        [class]="hairFrontCardOffsetClass"
        class="tw-px-4 tw-overflow-visible tw-relative">
        @if (isFallingHair) {
          <div class="tw-px-5 tw-pt-4 tw-pb-4.5 tw-bg-white tw-rounded-4.5 tw-shadow-z4">
            <div class="tw-flex tw-items-center tw-gap-1.5 tw-font-body tw-text-200 tw-font-bold tw-text-red-500">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <mask id="mask0_65333_85297" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
                  <rect width="18" height="18" fill="#E34D4D"/>
                </mask>
                <g mask="url(#mask0_65333_85297)">
                  <path d="M0.75 15.75L9 1.5L17.25 15.75H0.75ZM3.3375 14.25H14.6625L9 4.5L3.3375 14.25ZM9.53438 13.2844C9.67813 13.1406 9.75 12.9625 9.75 12.75C9.75 12.5375 9.67813 12.3594 9.53438 12.2156C9.39062 12.0719 9.2125 12 9 12C8.7875 12 8.60938 12.0719 8.46563 12.2156C8.32188 12.3594 8.25 12.5375 8.25 12.75C8.25 12.9625 8.32188 13.1406 8.46563 13.2844C8.60938 13.4281 8.7875 13.5 9 13.5C9.2125 13.5 9.39062 13.4281 9.53438 13.2844ZM8.25 11.25H9.75V7.5H8.25V11.25Z" fill="#E34D4D"/>
                </g>
              </svg>
              <span i18n="@@hairlineNotDetected">
                Hairline not detected
              </span>
            </div>
            <div class="tw-font-lexend tw-font-bold tw-text-gray-800 tw-leading-6 tw-mt-2"
              [class.tw-text-500]="isDravidianScriptUser"
              [class.tw-text-650]="!isDravidianScriptUser"
              [class.tw-mb-3]="isDravidianScriptUser"
              [class.tw-mb-1]="!isDravidianScriptUser"
              i18n="@@fallingHairTitle">
              Your hairs are covering your forehead/hairline
            </div>
            <div class="tw-border-t tw-border-gray-200 tw-mt-3"></div>
            <div class="tw-pt-2.5 tw-font-body tw-text-200 tw-text-gray-500">
              <span i18n="@@fallingHairDescription">Pull your hair back with your hand and retake the photo for accurate assessment.</span>
              <span class="tw-font-bold tw-text-teal-600 tw-cursor-pointer tw-ml-1"
                (click)="seeHowRetake()"
                i18n="@@fallingHairSeeHow">
                See how >
              </span>
            </div>
          </div>
        }
        @if (showHairFrontStateCard) {
          <div class="tw-px-5 tw-pt-4 tw-pb-4.5 tw-bg-white tw-rounded-4.5 tw-shadow-z4">
            <div class="tw-font-lexend tw-font-bold tw-text-gray-800 tw-leading-7"
              [class.tw-text-600]="isDravidianScriptUser"
              [class.tw-text-650]="!isDravidianScriptUser"
              [class.tw-mb-3]="isDravidianScriptUser"
              [class.tw-mb-1]="!isDravidianScriptUser">
              @switch (hairFrontCardState) {
                @case (HairFrontCardState.TempleBaldness) {
                  <span i18n="@@templeBaldnessDetected">Temple Baldness Detected</span>
                }
                @case (HairFrontCardState.Captured) {
                  <span i18n="@@hairFrontCaptured">Hair Front Captured</span>
                }
              }
            </div>
            <div class="tw-border-t tw-border-gray-200"></div>
            <div class="tw-pt-2.5 tw-font-body tw-text-200 tw-text-gray-500">
              @switch (hairFrontCardState) {
                @case (HairFrontCardState.TempleBaldness) {
                  <span i18n="@@templeBaldnessDetectedDescription">Hair around your temples is thinning in an M-shaped pattern — caused by DHT, a hormone that weakens follicles. Don't worry! This is treatable if you start early.</span>
                }
                @case (HairFrontCardState.Captured) {
                  <span i18n="@@hairFrontCapturedDescription">Your doctor will analyse this photo along with your scalp photo to assess your hairline pattern and check your hair health.</span>
                }
              }
            </div>
          </div>
        }
        @if (showLegacyTempleBaldnessCard) {
          <div
            class="tw-px-6 tw-shadow-z3 tw-pt-4 tw-box-border tw-min-h-[136px] tw-bg-white tw-rounded-xl tw-z-20 tw-overflow-visible">
            <div class="tw-font-body tw-font-bold tw-text-500 tw-mb-1" i18n="@@templeBaldness">
              Temple Baldness
            </div>
            @if (isIdealHairlineShown) {
              <div class="tw-font-body tw-text-200 tw-text-gray-700 tw-line-clamp-3 tw-overflow-hidden tw-text-ellipsis" i18n="@@thinningOrLossOfHairMShape">
                Thinning or loss of hair on forehead sides. The M-shape suggests you may have a receding hairline.
              </div>
              <div
                class="tw-font-body tw-text-200 tw-text-gray-700 tw-h-[54px] tw-line-clamp-3 tw-overflow-hidden tw-text-ellipsis">
                <span i18n="@@causesOfHairfallBold"><b>Causes:</b> genetics, hormones, ageing, stress or diet</span>
              </div>
            } @else {
              <div class="tw-font-body tw-text-200 tw-text-gray-700 tw-line-clamp-3 tw-overflow-hidden tw-text-ellipsis" i18n="@@thiningOrLossOfHair">
                Thinning or loss of hair on forehead sides.
              </div>
              <div
                class="tw-font-body tw-text-200 tw-text-gray-700 tw-h-[54px] tw-line-clamp-3 tw-overflow-hidden tw-text-ellipsis">
                <span i18n="@@causesOfHairfall">Causes: genetics, hormones, aging, stress or diet</span>
              </div>
            }
          </div>
        }
        @if (showHairlineMappedCard) {
          <div class="tw-px-5 tw-pt-4 tw-pb-4.5 tw-bg-white tw-rounded-4.5 tw-shadow-z4">
            <div class="tw-font-lexend tw-font-bold tw-text-gray-800"
              [class.tw-text-600]="isDravidianScriptUser"
              [class.tw-text-650]="!isDravidianScriptUser"
              [class.tw-mb-3]="isDravidianScriptUser"
              [class.tw-mb-1]="!isDravidianScriptUser"
              i18n="@@hairlineMapped">
              Hairline Mapped
            </div>
            <div class="tw-border-t tw-border-gray-200"></div>
            <div class="tw-pt-2.5 tw-font-body tw-text-200 tw-text-gray-500" i18n="@@hairlineMappedDescription">
              We've captured your hairline pattern. Your doctor will review this along with your other photos to assess your hair health.
            </div>
          </div>
        }
      </div>
    }
  </footer>
}
@if (blurWithoutConcernsDetected && handleBlurPhotosExperiment) {
  <div class="tw-h-14">
    <div [ngClass]="(user.get('languagePreference') === 'ta' || user.get('languagePreference') === 'te' || user.get('languagePreference') === 'kn') ? '-tw-translate-y-[117px]': '-tw-translate-y-[85px]'"
      class="tw-w-[90%] mx-auto tw-left-5 tw-right-5 tw-bg-orange-50 tw-border tw-border-orange-400 tw-px-4 tw-py-4 tw-mb-4 tw-text-left tw-rounded-xl">
      <div class="tw-flex tw-justify-start tw-items-start tw-mb-2">
        <img src="/assets/icons/warning.svg"
          class="tw-w-4 tw-h-4 tw-mr-1 tw-mt-0.5"
          alt="warning_icon" />
        <h1 i18n="@@imageNotClear"
        class="tw-text-orange-400 tw-text-400 tw-font-body tw-font-bold">Image Not Clear</h1>
      </div>
      <h1 i18n="@@retakePhoto"
      class="tw-text-200 tw-mb-2">Retake photo, by trying the following things:</h1>
      <div class="tw-text-200 tw-pl-2">
        <h1>1. <span i18n="@@cleanCamera">Clean your camera</span></h1>
        <h1>2. <span i18n="@@dontMove">Don't move while taking picture</span> </h1>
        <h1>3. <span i18n="@@useBackCamera">Use back camera</span></h1>
      </div>
    </div>
  </div>
}
@if (instantCheckup && isInvalidPhoto) {
  @if (isHairFlowInvalidPhoto) {
    <app-hair-photo-not-detected-card
      [copy]="hairPhotoNotDetectedCopy"
      [titleSizeClass]="isDravidianScriptUser ? 'tw-text-400' : 'tw-text-500'"
      [descriptionSizeClass]="isDravidianScriptUser ? 'tw-text-100' : 'tw-text-200'" />
  } @else {
    <app-invalid-photo-error-card [uiCode]="resolvedInvalidPhotoUiCode" />
  }
}
<!-- Footer buttons -->
<footer class="tw-px-3 tw-bg-gray-100"
  [ngClass]="instantCheckup && isInvalidPhoto ? 'tw-pb-5' : 'tw-py-5'">
    <div [ngClass]="footerLayout.containerVariant === FooterContainerVariant.DEFAULT
            ? 'tw-flex tw-gap-3'
            : 'tw-w-full tw-flex tw-justify-center tw-items-center tw-gap-2 tw-px-2'">
    @for (button of footerLayout.buttons; track button.i18nKey) {
      @if (button.shouldShow) {
        <div class="tw-flex-1 tw-rounded-3 tw-font-semibold tw-flex tw-justify-center tw-items-center tw-font-body tw-py-3"
          [ngClass]="[button.cssClasses, footerLayout.containerVariant === FooterContainerVariant.DEFAULT ? 'tw-h-[48px]' : '']"
          (click)="button.action()">
          @switch (button.i18nKey) {
            @case (I18nKey.RE_TAKE_PHOTO) {
              <span i18n="@@reTakePhoto">Re-Take Photo</span>
            }
            @case (I18nKey.CHECK_AGAIN) {
              <span i18n="@@checkAgain">Check Again</span>
            }
            @case (I18nKey.RETAKE) {
              <span i18n="@@retake">Retake</span>
            }
            @case (I18nKey.CONTINUE) {
              <span i18n="@@continue">Continue</span>
            }
            @case (I18nKey.CHANGE) {
              <span i18n="@@change">Change</span>
            }
            @case (I18nKey.SHARE_WITH_DOCTOR) {
              <span i18n="@@shareWithDoctor">Share with Doctor</span>
            }
          }
        </div>
      }
    }
  </div>
</footer>
}
}

<pop-up-modal [config]="ui.popUpModal"
(close)="popUpClosed($event)"></pop-up-modal>
